<template>
  <div class="form-links my-2 my-md-0 px-i">
    <div class="form-links-wrapper justify-content-center container-fluid">
      <div class="btn-group filter-group">
        <a :href="invoiceLink" class="btn btn-outline-primary filter-group-button col-8" :class="activeState('Invoice')">
          Invoice
        </a>
        <a :href="receiptLink" class="btn btn-outline-primary filter-group-button col-8" :class="activeState('Receipt')">
          Receipt
        </a>
        <a v-if="showPayout" :href="payoutLink" class="btn btn-outline-primary filter-group-button col-8" :class="activeState('Payout')">
          Payout
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InvoiceTabs",

  props: ["invoiceHash", "showPayout", "activeTab"],

  computed: {
    invoiceLink () {
      if (this.activeTab === "Invoice") {
        return "#";
      } else {
        return `dashboard#/invoices/${this.invoiceHash}`;
      }
    },

    receiptLink () {
      if (this.activeTab === "Receipt") {
        return "#";
      } else {
        return `dashboard#/invoices/${this.invoiceHash}/receipt`;
      }
    },

    payoutLink () {
      if (this.activeTab === "Payout") {
        return "#";
      } else {
        return `dashboard#/invoices/${this.invoiceHash}/payout`;
      }
    }
  },

  methods: {
    activeState (currentTab) {
      if (currentTab === this.activeTab) {
        return "active"
      };
    }
  }
}
</script>
